<template>
    <div class="page page--light page--gradient-background">
        <div class="wrapper">
            <section v-if="!loadingCategory"
                class="row header"
            >
                <header class="row__header header__main">
                    <back-button :isBlack="true"
                        :isAbsolute="false"
                    />
                    <h1 v-if="category && category.name"
                        id="fanshop-products-title"
                    >
                        {{ getTranslatedStr(category, 'name', category.name) }}
                    </h1>
                    <partner-filter-toggle v-if="category && (variants.length || getPartnersFiltered().length)" />
                </header>
            </section>
            <section>
                <products-list
                    :variants="variants"
                    :subCategories="currentCategorySubcategories"
                    :loadingProducts="loadingProducts"
                    :loadingCategory="loadingCategory"
                    @update:productsByFilter="handleUpdateProductsByFilter"
                    @update:productsByPage="handleUpdateProductsByPage"
                />
            </section>
        </div>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';
import partnerFilterToggle from '@webapp/modules/rewards/components/fanshop/partner-filter-toggle.vue';
import productsList from '@webapp/modules/rewards/components/fanshop/products-list.vue';

export default {
    name: 'fanshop-products',
    components: {
        backButton,
        partnerFilterToggle,
        productsList,
    },
    data() {
        return {
            loadingProducts: true,
            loadingCategory: true,
            categoryId: this.$route.params.categoryId,
            category: null,
            pageLimit: 15,
        };
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),

        ...mapGetters('fanshop', [
            'getProductVariantsByCategory',
            'getProductCategoriesById',
            'getSubCategoriesFilterById',
        ]),

        ...mapGetters('partners', [
            'getPartnersFiltered',
            'getAllPartnersFiltered',
        ]),

        variants() {
            return this.getProductVariantsByCategory.data || [];
        },

        currentCategory() {
            return this.getProductCategoriesById[this.categoryId];
        },

        currentCategorySubcategories() {
            return this.currentCategory?.subCategories;
        },

        categorySubcategoriesIds() {
            return this.currentCategory?.subCategories.map((cat) => cat.id);
        },
        subCategoryIdsByUrlParams() {
            const params = new URLSearchParams(this.$route.hash.replace('#', '?'));
            const subCatIds = params.get('selected')?.length ? [...params.get('selected').split(',')] : [];

            return subCatIds.length ? subCatIds : [];
        },
    },
    watch: {
        async 'getAllPartnersFiltered.default'() {
            await this.fetchProductCategories({
                partnerIds: this.getPartnersFiltered()?.map((partner) => partner.id) || [],
            });

            await this.loadProductsForCategory(this.getSubCategoriesFilterById);

        },
        async 'getSubCategoriesFilterById'() {
            await this.loadProductsForCategory(this.getSubCategoriesFilterById, this.$route.query.page || 1);
        },
    },
    async mounted() {
        await this.fetchProductCategories({
            partnerIds: this.getPartnersFiltered()?.map((partner) => partner.id) || [],
        });

        this.updateSubCategoriesFilterById(this.subCategoryIdsByUrlParams);

        this.loadingCategory = false;

        this.category = this.currentCategory;
    },
    methods: {
        ...mapActions('fanshop', [
            'fetchProductCategories',
            'fetchProductsByCategoryId',
            'updateSubCategoriesFilterById',
        ]),

        async loadProductsForCategory(subCategories = [], page = 1, append = false) {
            this.loadingProducts = true;

            await this.fetchProductsByCategoryId({
                categoryIds: subCategories.length === 0 ? this.categorySubcategoriesIds : subCategories,
                partnerIds: this.getPartnersFiltered()?.map((partner) => partner.id),
                limit: this.pageLimit,
                page,
                append,
                getAlsoOutOfStockProducts: true,
            });
            this.loadingProducts = false;
        },
        handleUpdateProductsByFilter(selectedSubCategories) {
            this.updateSubCategoriesFilterById(selectedSubCategories);
        },
        async handleUpdateProductsByPage(chosenSubcategoryIds, page) {
            await this.loadProductsForCategory(chosenSubcategoryIds, page);
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    ::v-deep .chips-carousel {
        margin: 3rem 0 3rem 0;
    }
}

.wrapper {
    .row {
        padding: 0 1.6rem;

        @include min-width(xl) {
            padding: 0 0.8rem;
        }

        @include min-width(xxl) {
            padding: 0 0;
        }
    }
}
</style>